import React, { useState, Fragment } from 'react';
import { CheckCircle2, Crown, TrendingUp, ShoppingBag, DollarSign, Download, ChevronDown, ChevronUp, X, AlertTriangle, Zap, Search, Star, Shield, Headphones, BarChart3, Megaphone, CreditCard, ArrowRight, XCircle, Wallet, Bell } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
interface SubscriptionTabProps {
  showToast: (msg: string) => void;
}
const PAYMENTS = [{
  id: 1,
  date: '15 Мар 2026',
  desc: 'Продление PRO',
  amount: '990 ₽',
  method: 'Visa ···4582',
  status: 'paid' as const
}, {
  id: 2,
  date: '15 Фев 2026',
  desc: 'Продление PRO',
  amount: '990 ₽',
  method: 'Visa ···4582',
  status: 'paid' as const
}, {
  id: 3,
  date: '15 Янв 2026',
  desc: 'Продление PRO',
  amount: '990 ₽',
  method: 'Visa ···4582',
  status: 'paid' as const
}, {
  id: 4,
  date: '15 Дек 2025',
  desc: 'Продление PRO',
  amount: '990 ₽',
  method: 'Visa ···4582',
  status: 'paid' as const
}, {
  id: 5,
  date: '15 Ноя 2025',
  desc: 'Переход на PRO',
  amount: '990 ₽',
  method: 'Visa ···4582',
  status: 'paid' as const
}];
const PLANS = [{
  id: 'free',
  name: 'Базовый',
  price: 0,
  priceLabel: '0 ₽',
  period: 'бесплатно',
  color: 'slate',
  features: {
    consultations: '5 / мес',
    commission: '25%',
    priority: 'Нет',
    limits: '3 услуги',
    advertising: 'Нет',
    analytics: 'Базовая',
    support: 'Email'
  },
  included: ['5 консультаций/мес', 'Комиссия 25%', 'Базовая аналитика', '3 услуги в каталоге'],
  missing: ['Приоритет в поиске', 'Продвижение', 'Расширенная аналитика']
}, {
  id: 'pro',
  name: 'PRO',
  price: 990,
  priceLabel: '990 ₽',
  period: '/мес',
  color: 'indigo',
  popular: true,
  features: {
    consultations: 'Безлимитно',
    commission: '15%',
    priority: 'Да',
    limits: '20 услуг',
    advertising: 'Базовое',
    analytics: 'Полная',
    support: 'Приоритетный'
  },
  included: ['Безлимитно консультаций', 'Комиссия 15%', 'Полная аналитика', '20 услуг', 'Приоритет в поиске', 'Базовое продвижение'],
  missing: ['Топ в каталоге', 'Персональный менеджер']
}, {
  id: 'top',
  name: 'TOP',
  price: 2490,
  priceLabel: '2 490 ₽',
  period: '/мес',
  color: 'amber',
  features: {
    consultations: 'Безлимитно',
    commission: '10%',
    priority: 'Топ',
    limits: 'Безлимитно',
    advertising: 'Премиум',
    analytics: 'Полная + AI',
    support: 'Персональный менеджер'
  },
  included: ['Безлимитно всё', 'Комиссия 10%', 'AI-аналитика', 'Топ в каталоге', 'Премиум продвижение', 'Персональный менеджер'],
  missing: []
}];
const FEATURE_ROWS = [{
  key: 'consultations',
  label: 'Консультации',
  icon: ShoppingBag
}, {
  key: 'commission',
  label: 'Комиссия',
  icon: DollarSign
}, {
  key: 'priority',
  label: 'Приоритет в поиске',
  icon: Search
}, {
  key: 'limits',
  label: 'Лимит услуг',
  icon: BarChart3
}, {
  key: 'advertising',
  label: 'Продвижение',
  icon: Megaphone
}, {
  key: 'analytics',
  label: 'Аналитика',
  icon: TrendingUp
}, {
  key: 'support',
  label: 'Поддержка',
  icon: Headphones
}];
export function SubscriptionTab({
  showToast
}: SubscriptionTabProps) {
  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [expandedPayment, setExpandedPayment] = useState<number | null>(null);
  const [payFromBalance, setPayFromBalance] = useState(true);
  const currentPlan = PLANS.find(p => p.id === 'pro')!;
  const accountBalance = 24500;
  const togglePayment = (id: number) => {
    setExpandedPayment(prev => prev === id ? null : id);
  };
  return <div className="space-y-6" data-id="element-15109">
      {/* Header */}
      <div data-id="element-15110">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-15111">Подписка</h2>
        <p className="text-slate-500 text-sm mt-0.5" data-id="element-15112">Тариф, платежи, выгода</p>
      </div>

      {/* Current Plan */}
      <Card padding="md" className="border-indigo-200 bg-gradient-to-br from-indigo-50/50 to-purple-50/30" data-id="element-15113">
        <div className="flex flex-col sm:flex-row justify-between items-start gap-4 mb-5" data-id="element-15114">
          <div data-id="element-15115">
            <div className="flex items-center gap-2 mb-1" data-id="element-15116">
              <Crown className="w-5 h-5 text-indigo-600" data-id="element-15117" />
              <h3 className="text-xl font-bold text-indigo-900" data-id="element-15118">Тариф PRO</h3>
              <Badge variant="pro" data-id="element-15119">Активен</Badge>
            </div>
            <p className="text-sm text-indigo-700" data-id="element-15120">
              Следующее списание: 15 Апреля 2026 ·{' '}
              <span className="font-bold" data-id="element-15121">990 ₽/мес</span>
            </p>
          </div>
          <div className="flex gap-2 w-full sm:w-auto" data-id="element-15122">
            {cancelConfirm ? <div className="flex flex-col gap-2 p-3 bg-rose-50 border border-rose-200 rounded-xl w-full sm:w-auto" data-id="element-15123">
                <div className="flex items-center gap-2 text-sm text-rose-700 font-medium" data-id="element-15124">
                  <AlertTriangle className="w-4 h-4" data-id="element-15125" /> Вы потеряете:
                </div>
                <ul className="text-xs text-rose-600 space-y-0.5 ml-6" data-id="element-15126">
                  <li data-id="element-15127">• Приоритет в поиске</li>
                  <li data-id="element-15128">• Комиссия вырастет до 25%</li>
                  <li data-id="element-15129">• Лимит 5 консультаций/мес</li>
                </ul>
                <div className="flex gap-2 mt-1" data-id="element-15130">
                  <Button variant="outline" size="sm" className="border-rose-200 text-rose-600 hover:bg-rose-100" onClick={() => {
                setCancelConfirm(false);
                showToast('Подписка будет отменена в конце периода');
              }} data-id="element-15131">
                    Да, отменить
                  </Button>
                  <Button variant="outline" size="sm" onClick={() => setCancelConfirm(false)} data-id="element-15132">
                    Оставить
                  </Button>
                </div>
              </div> : <>
                <Button variant="outline" size="sm" className="text-slate-500 flex-1 sm:flex-none" onClick={() => setCancelConfirm(true)} data-id="element-15133">
                  Отменить
                </Button>
                <Button variant="primary" size="sm" className="flex-1 sm:flex-none" icon={<Zap className="w-4 h-4" data-id="element-15135" />} onClick={() => {
              const el = document.getElementById('plans-section');
              el?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-15134">
                  Улучшить тариф
                </Button>
              </>}
          </div>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5" data-id="element-15136">
          <div className="bg-white/70 rounded-xl p-3 border border-indigo-100" data-id="element-15137">
            <div className="text-[10px] text-indigo-500 font-medium uppercase tracking-wider mb-0.5" data-id="element-15138">
              Заказов за месяц
            </div>
            <div className="text-lg font-bold text-indigo-900 flex items-center gap-1" data-id="element-15139">
              +12 <TrendingUp className="w-4 h-4 text-emerald-500" data-id="element-15140" />
            </div>
          </div>
          <div className="bg-white/70 rounded-xl p-3 border border-indigo-100" data-id="element-15141">
            <div className="text-[10px] text-indigo-500 font-medium uppercase tracking-wider mb-0.5" data-id="element-15142">
              Доход за месяц
            </div>
            <div className="text-lg font-bold text-indigo-900" data-id="element-15143">68 400 ₽</div>
          </div>
          <div className="bg-white/70 rounded-xl p-3 border border-indigo-100" data-id="element-15144">
            <div className="text-[10px] text-indigo-500 font-medium uppercase tracking-wider mb-0.5" data-id="element-15145">
              Комиссия
            </div>
            <div className="text-lg font-bold text-indigo-900" data-id="element-15146">15%</div>
          </div>
          <div className="bg-white/70 rounded-xl p-3 border border-indigo-100" data-id="element-15147">
            <div className="text-[10px] text-indigo-500 font-medium uppercase tracking-wider mb-0.5" data-id="element-15148">
              Приоритет
            </div>
            <div className="text-lg font-bold text-emerald-600 flex items-center gap-1" data-id="element-15149">
              <CheckCircle2 className="w-4 h-4" data-id="element-15150" /> Да
            </div>
          </div>
        </div>

        {/* What's included */}
        <div className="pt-4 border-t border-indigo-100" data-id="element-15151">
          <div className="text-xs font-bold text-indigo-700 uppercase tracking-wider mb-2" data-id="element-15152">
            Что входит в PRO
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5" data-id="element-15153">
            {currentPlan.included.map(f => <div key={f} className="flex items-center gap-1.5 text-sm text-indigo-800" data-id="element-15154">
                <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500 shrink-0" data-id="element-15155" />{' '}
                {f}
              </div>)}
          </div>
        </div>
      </Card>

      {/* Payment Method & Notifications */}
      <Card padding="md" data-id="element-15156">
        <h3 className="font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-15157">
          <Wallet className="w-5 h-5 text-slate-400" data-id="element-15158" /> Способ оплаты подписки
        </h3>
        <div className="flex flex-col sm:flex-row gap-3 mb-4" data-id="element-15159">
          <button onClick={() => {
          setPayFromBalance(true);
          showToast('Подписка будет списываться с баланса');
        }} className={`flex-1 p-3 rounded-xl border text-left transition-colors ${payFromBalance ? 'border-indigo-500 bg-indigo-50/50 ring-1 ring-indigo-500' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-15160">
            <div className="flex items-center gap-2 mb-1" data-id="element-15161">
              <Wallet className="w-4 h-4 text-indigo-600" data-id="element-15162" />
              <span className="font-bold text-sm text-slate-900" data-id="element-15163">
                С баланса
              </span>
              {payFromBalance && <Badge variant="success" size="sm" data-id="element-15164">
                  Активно
                </Badge>}
            </div>
            <div className="text-xs text-slate-500" data-id="element-15165">
              Баланс:{' '}
              <span className="font-bold text-slate-700" data-id="element-15166">
                {new Intl.NumberFormat('ru-RU').format(accountBalance)} ₽
              </span>
            </div>
          </button>
          <button onClick={() => {
          setPayFromBalance(false);
          showToast('Подписка будет списываться с карты');
        }} className={`flex-1 p-3 rounded-xl border text-left transition-colors ${!payFromBalance ? 'border-indigo-500 bg-indigo-50/50 ring-1 ring-indigo-500' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-15167">
            <div className="flex items-center gap-2 mb-1" data-id="element-15168">
              <CreditCard className="w-4 h-4 text-slate-600" data-id="element-15169" />
              <span className="font-bold text-sm text-slate-900" data-id="element-15170">С карты</span>
              {!payFromBalance && <Badge variant="success" size="sm" data-id="element-15171">
                  Активно
                </Badge>}
            </div>
            <div className="text-xs text-slate-500" data-id="element-15172">Visa •••• 4582</div>
          </button>
        </div>
        <div className="flex items-start gap-2 p-3 bg-amber-50 border border-amber-100 rounded-lg" data-id="element-15173">
          <Bell className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" data-id="element-15174" />
          <div className="text-xs text-amber-700" data-id="element-15175">
            <span className="font-medium" data-id="element-15176">Уведомление:</span> за 3 дня до
            списания вы получите напоминание. Следующее списание{' '}
            <span className="font-bold" data-id="element-15177">990 ₽</span> — 15 Апреля 2026{' '}
            {payFromBalance ? 'с баланса' : 'с карты'}.
          </div>
        </div>
      </Card>

      {/* Why Upgrade */}
      <Card padding="md" className="border-amber-200 bg-amber-50/30" data-id="element-15178">
        <div className="flex items-center gap-2 mb-3" data-id="element-15179">
          <Zap className="w-5 h-5 text-amber-600" data-id="element-15180" />
          <h3 className="font-bold text-slate-900" data-id="element-15181">
            Почему стоит улучшить тариф
          </h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-15182">
          {[{
          stat: '+40%',
          label: 'заказов',
          desc: 'Астрологи на TOP получают на 40% больше заказов'
        }, {
          stat: 'Топ-3',
          label: 'в каталоге',
          desc: 'Ваш профиль показывается первым в поиске'
        }, {
          stat: '-10%',
          label: 'комиссия',
          desc: 'Экономия до 15% на комиссии с каждого заказа'
        }].map(item => <div key={item.label} className="bg-white rounded-xl p-3 border border-amber-100" data-id="element-15183">
              <div className="text-2xl font-bold text-amber-700 mb-0.5" data-id="element-15184">
                {item.stat}
              </div>
              <div className="text-sm font-medium text-slate-900 mb-0.5" data-id="element-15185">
                {item.label}
              </div>
              <div className="text-xs text-slate-500" data-id="element-15186">{item.desc}</div>
            </div>)}
        </div>
        <Button variant="primary" size="sm" className="mt-4 bg-amber-600 hover:bg-amber-700" icon={<ArrowRight className="w-4 h-4" data-id="element-15188" />} onClick={() => {
        const el = document.getElementById('plans-section');
        el?.scrollIntoView({
          behavior: 'smooth'
        });
      }} data-id="element-15187">
          Перейти на TOP
        </Button>
      </Card>

      {/* Plan Comparison */}
      <div id="plans-section" data-id="element-15189">
        <h3 className="font-bold text-slate-900 text-lg mb-4" data-id="element-15190">Выбор тарифа</h3>

        {/* Mobile: Cards */}
        <div className="sm:hidden space-y-3" data-id="element-15191">
          {PLANS.map(plan => {
          const isCurrent = plan.id === 'pro';
          return <Card key={plan.id} padding="md" className={`${isCurrent ? 'border-indigo-500 ring-1 ring-indigo-500' : 'border-slate-200'} ${plan.id === 'top' ? 'border-amber-400' : ''}`} data-id="element-15192">
                <div className="flex items-center justify-between mb-2" data-id="element-15193">
                  <div className="flex items-center gap-2" data-id="element-15194">
                    <span className="font-bold text-lg text-slate-900" data-id="element-15195">
                      {plan.name}
                    </span>
                    {isCurrent && <Badge variant="pro" size="sm" data-id="element-15196">
                        Текущий
                      </Badge>}
                    {plan.id === 'top' && !isCurrent && <Badge variant="warning" size="sm" data-id="element-15197">
                        Популярный
                      </Badge>}
                  </div>
                </div>
                <div className="mb-3" data-id="element-15198">
                  <span className="text-2xl font-bold text-slate-900" data-id="element-15199">
                    {plan.priceLabel}
                  </span>
                  <span className="text-sm text-slate-500" data-id="element-15200">{plan.period}</span>
                </div>
                <ul className="space-y-1.5 mb-4" data-id="element-15201">
                  {plan.included.map(f => <li key={f} className="text-sm text-slate-700 flex items-center gap-1.5" data-id="element-15202">
                      <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500 shrink-0" data-id="element-15203" />{' '}
                      {f}
                    </li>)}
                  {plan.missing.map(f => <li key={f} className="text-sm text-slate-400 flex items-center gap-1.5" data-id="element-15204">
                      <XCircle className="w-3.5 h-3.5 text-slate-300 shrink-0" data-id="element-15205" />{' '}
                      {f}
                    </li>)}
                </ul>
                {isCurrent ? <div className="text-center text-sm text-indigo-600 font-medium py-2" data-id="element-15206">
                    Ваш текущий тариф
                  </div> : <Button variant={plan.id === 'top' ? 'primary' : 'outline'} fullWidth onClick={() => showToast(`Переход на ${plan.name}`)} data-id="element-15207">
                    {plan.price > 990 ? 'Улучшить' : plan.price === 0 ? 'Перейти' : 'Выбрать'}
                  </Button>}
              </Card>;
        })}
        </div>

        {/* Desktop: Comparison Table */}
        <Card padding="none" className="hidden sm:block overflow-hidden" data-id="element-15208">
          <table className="w-full text-sm" data-id="element-15209">
            <thead data-id="element-15210">
              <tr className="border-b border-slate-100" data-id="element-15211">
                <th className="text-left px-4 py-3 text-xs font-medium text-slate-500 w-1/4" data-id="element-15212">
                  Возможность
                </th>
                {PLANS.map(plan => <th key={plan.id} className={`px-4 py-3 text-center ${plan.id === 'pro' ? 'bg-indigo-50/50' : plan.id === 'top' ? 'bg-amber-50/50' : ''}`} data-id="element-15213">
                    <div className="font-bold text-slate-900" data-id="element-15214">{plan.name}</div>
                    <div className="text-xs text-slate-500 mt-0.5" data-id="element-15215">
                      {plan.priceLabel}
                      {plan.period}
                    </div>
                    {plan.id === 'pro' && <Badge variant="pro" size="sm" className="mt-1" data-id="element-15216">
                        Текущий
                      </Badge>}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-15217">
              {FEATURE_ROWS.map(row => <tr key={row.key} className="hover:bg-slate-50/50" data-id="element-15218">
                  <td className="px-4 py-2.5 text-slate-700 flex items-center gap-2" data-id="element-15219">
                    <row.icon className="w-4 h-4 text-slate-400" data-id="element-15220" /> {row.label}
                  </td>
                  {PLANS.map(plan => <td key={plan.id} className={`px-4 py-2.5 text-center font-medium ${plan.id === 'pro' ? 'bg-indigo-50/30 text-indigo-700' : plan.id === 'top' ? 'bg-amber-50/30 text-amber-700' : 'text-slate-600'}`} data-id="element-15221">
                      {(plan.features as Record<string, string>)[row.key]}
                    </td>)}
                </tr>)}
            </tbody>
            <tfoot data-id="element-15222">
              <tr className="border-t border-slate-200" data-id="element-15223">
                <td className="px-4 py-3" data-id="element-15224"></td>
                {PLANS.map(plan => <td key={plan.id} className={`px-4 py-3 text-center ${plan.id === 'pro' ? 'bg-indigo-50/30' : plan.id === 'top' ? 'bg-amber-50/30' : ''}`} data-id="element-15225">
                    {plan.id === 'pro' ? <span className="text-sm text-indigo-600 font-medium" data-id="element-15226">
                        Текущий тариф
                      </span> : <Button variant={plan.id === 'top' ? 'primary' : 'outline'} size="sm" fullWidth onClick={() => showToast(`Переход на ${plan.name}`)} data-id="element-15227">
                        {plan.price > 990 ? 'Улучшить' : 'Выбрать'}
                      </Button>}
                  </td>)}
              </tr>
            </tfoot>
          </table>
        </Card>
      </div>

      {/* Payment History */}
      <div data-id="element-15228">
        <h3 className="font-bold text-slate-900 text-lg mb-4" data-id="element-15229">
          История платежей
        </h3>
        <Card padding="none" className="overflow-hidden" data-id="element-15230">
          {/* Desktop */}
          <div className="hidden sm:block" data-id="element-15231">
            <table className="w-full text-sm text-left" data-id="element-15232">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-100" data-id="element-15233">
                <tr data-id="element-15234">
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15235">Дата</th>
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15236">Описание</th>
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15237">Способ</th>
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15238">Сумма</th>
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15239">Статус</th>
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15240"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-15241">
                {PAYMENTS.map(p => <Fragment key={p.id} data-id="element-15242">
                    <tr className="hover:bg-slate-50 cursor-pointer" onClick={() => togglePayment(p.id)} data-id="element-15243">
                      <td className="px-4 py-2.5 text-slate-600 text-xs" data-id="element-15244">
                        {p.date}
                      </td>
                      <td className="px-4 py-2.5 font-medium text-slate-900 text-xs" data-id="element-15245">
                        {p.desc}
                      </td>
                      <td className="px-4 py-2.5 text-slate-500 text-xs" data-id="element-15246">
                        {p.method}
                      </td>
                      <td className="px-4 py-2.5 text-slate-900 text-xs font-medium" data-id="element-15247">
                        {p.amount}
                      </td>
                      <td className="px-4 py-2.5" data-id="element-15248">
                        <Badge variant="success" size="sm" data-id="element-15249">
                          Оплачено
                        </Badge>
                      </td>
                      <td className="px-4 py-2.5" data-id="element-15250">
                        {expandedPayment === p.id ? <ChevronUp className="w-4 h-4 text-slate-400" data-id="element-15251" /> : <ChevronDown className="w-4 h-4 text-slate-400" data-id="element-15252" />}
                      </td>
                    </tr>
                    {expandedPayment === p.id && <tr data-id="element-15253">
                        <td colSpan={6} className="px-4 py-3 bg-slate-50" data-id="element-15254">
                          <div className="flex items-center justify-between" data-id="element-15255">
                            <div className="text-xs text-slate-500 space-y-1" data-id="element-15256">
                              <div data-id="element-15257">
                                Чек №{1000 + p.id} · {p.date}
                              </div>
                              <div data-id="element-15258">Способ оплаты: {p.method}</div>
                              <div data-id="element-15259">Тариф: PRO · Период: 1 месяц</div>
                            </div>
                            <Button variant="outline" size="sm" icon={<Download className="w-3.5 h-3.5" data-id="element-15261" />} onClick={e => {
                        e.stopPropagation();
                        showToast('Чек скачан ✓');
                      }} data-id="element-15260">
                              Скачать чек
                            </Button>
                          </div>
                        </td>
                      </tr>}
                  </Fragment>)}
              </tbody>
            </table>
          </div>

          {/* Mobile */}
          <div className="sm:hidden divide-y divide-slate-100" data-id="element-15262">
            {PAYMENTS.map(p => <div key={p.id} data-id="element-15263">
                <div className="p-3 flex justify-between items-center cursor-pointer" onClick={() => togglePayment(p.id)} data-id="element-15264">
                  <div data-id="element-15265">
                    <div className="text-sm font-medium text-slate-900" data-id="element-15266">
                      {p.desc}
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-15267">
                      {p.date} · {p.method}
                    </div>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-15268">
                    <div className="text-right" data-id="element-15269">
                      <div className="text-sm font-bold text-slate-900" data-id="element-15270">
                        {p.amount}
                      </div>
                      <Badge variant="success" size="sm" data-id="element-15271">
                        Оплачено
                      </Badge>
                    </div>
                    {expandedPayment === p.id ? <ChevronUp className="w-4 h-4 text-slate-400" data-id="element-15272" /> : <ChevronDown className="w-4 h-4 text-slate-400" data-id="element-15273" />}
                  </div>
                </div>
                {expandedPayment === p.id && <div className="px-3 pb-3" data-id="element-15274">
                    <div className="bg-slate-50 rounded-lg p-3 space-y-2" data-id="element-15275">
                      <div className="text-xs text-slate-500" data-id="element-15276">
                        Чек №{1000 + p.id} · Тариф PRO · 1 месяц
                      </div>
                      <Button variant="outline" size="sm" fullWidth icon={<Download className="w-3.5 h-3.5" data-id="element-15278" />} onClick={() => showToast('Чек скачан ✓')} data-id="element-15277">
                        Скачать чек
                      </Button>
                    </div>
                  </div>}
              </div>)}
          </div>
        </Card>
      </div>
    </div>;
}